import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateBrandMetadata } from '../../api/brand.ts';
import { UpdateBrandMetadataRequest } from '../../api/requests/brand-request.ts';

export default function useUpdateBrandMetadata(): UseMutationResult<
  Awaited<ReturnType<typeof updateBrandMetadata>>,
  Error,
  UpdateBrandMetadataRequest
> {
  return useMutation({
    mutationFn: updateBrandMetadata,
  });
}
